<template>
  <div class="select-head fx-s-center">
    <el-tabs class="fx-full" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in tabOptions" :key="item.path" :label="item.label" :name="item.path" />
    </el-tabs>
  </div>
</template>

<script>     
import { mapState } from 'vuex'
export default {
  name: 'EnterpriseTabs',
  props: {

  },
  data() {
    return {
      activeIndustry: '',
      activeName: 'overview',
      tabOptions: [
        { label: '企业架构图', path: 'enterpriseGraph' },
        { label: '股权全景穿透', path: 'equityPenetration' },
        { label: '股东持股穿透', path: 'shareholderStructure' },
        { label: '对外投资穿透', path: 'investmentPenetration' }
      ],
      stroke: '#86909C'
    }
  },
  computed: {
    ...mapState({
      industryChain: state => state.asyncRoute.industryChain,
      theClassify: state => state.asyncRoute.theClassify,
      allChainList: state => state.asyncRoute.allChainList,
      chainIDMap: state => state.asyncRoute.chainIDMap,
    }),
    ID() {
      return this.$route?.query?.id
    },
    theChain() {
      return this.chainIDMap[this.ID]
    },
  },
  watch: {
    '$route': {
      deep: true,
      immediate: true,
      handler: function (val) {
        const { path } = val
        const lastSlashIndex = path.lastIndexOf('/')
        this.activeName = path.substring(lastSlashIndex + 1)
      }
    },
  },
  created() {

  },
  methods: {
    handleClick() {
      this.$router.push({ path: `/zxk/search/${this.activeName}`, query: this.$route.query })
    }
  },
}
</script>

<style scoped lang="scss">
.pad-16 {
  padding: 16px;
}
.select-head {
  ::v-deep {
    .el-dropdown {
      border-bottom: 1px solid #eeeeee;
      height: 39px;
      line-height: 39px;
    }
    .el-tabs__header {
      margin: 0;
    }
  }
  .back-btn {
    font-size: 0.9285714286rem;
    font-weight: 400;
    color: #86909c;
    cursor: pointer;
    border-bottom: 1px solid #eeeeee;
    height: 39px;
    line-height: 39px;

    &:hover {
      color: #1150fb;
    }
    .cust-icon {
      display: inline-block;
      color: inherit;
      font-style: normal;
      line-height: 0;
      text-align: center;
      text-transform: none;
      vertical-align: -0.125em;
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
      > svg {
        display: inline-block;
        width: 1em;
        height: 1em;
      }
    }
  }
}
</style>
